import React from "react";

import "./styles/FeatureBox.css";

const FeatureBox = props => {
  return (
    <div className="feature-box">
      <i className={`feature-box__icon icon-${props.icon}`} />
      <h3 className="freature-box__heading heading-tertiary u-margin-bottom-small">
        {props.title}
      </h3>
      <p className="feature-box__text">{props.description}</p>
    </div>
  );
};

export default FeatureBox;



// WEBPACK FOOTER //
// ./src/components/sections/Section-Features/FeatureBox.js